import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

export const state_augmontApi = createAsyncThunk("state_augmont", async () => {
  const response = await axiosInstance.get("/state_augmont");
  return response.data;
});

const state_augmontSlice = createSlice({
  name: "state_augmont",
  initialState: {
    state_augmont: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(state_augmontApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(state_augmontApi.fulfilled, (state, action) => {
        state.state_augmont = action.payload;
        state.loading = false;
      })
      .addCase(state_augmontApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default state_augmontSlice.reducer;
